import { Component, Input, Output, OnInit, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
declare let d3;

@Component({
  selector: 'si-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartLegendComponent implements OnInit, OnChanges {

  @Input() id: string;
  @Input() data: object;
  @Input() textCallback: (d: object, i: number) => string;
  @Input() colorCallback: (d: object, i: number) => string;
  @Input() clickable: boolean = true;
  @Output() legendClicked = new EventEmitter();


  private legendContainerElem;
  private legendContainer;
  private isPlotted: boolean = false;

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {
    if (this.data !== undefined) {
      if (!this.isPlotted) {
        this.legendContainerElem = this.createLegendContainer();
        this.isPlotted = true;
      }
      this.createLegend();
    }
  }

  createLegendContainer() {
    this.legendContainer = d3.select('#' + this.id + ' #legendContainerComp');
    const height = this.legendContainer.node().getBoundingClientRect().height ||
      this.legendContainer.node().parentNode.getBoundingClientRect().height;

    const legendContainerElem = this.legendContainer
      .append('svg')
      .attr('height', height)
      .append('g')
      .attr('class', 'si-legend-group');
    return legendContainerElem;
  }

  createLegend() {
    const width = this.legendContainer.node().parentNode.getBoundingClientRect().width ||
      this.legendContainer.node().getBoundingClientRect().width;
    this.legendContainer
      .select('svg')
      .attr('width', width)
      .select('.si-legend-group')
      .attr('transform', 'translate(' + (width + 10) + ', 2)');

    const self = this;
    const redius = 5;
    const textDimensionInfo = [];
    const legendDataJoin = this.legendContainerElem.selectAll('.si-chart-legend')
      .remove()
      .exit()
      .data(this.data);

    const legend = legendDataJoin.enter()
      .append('g')
      .attr('class', 'si-chart-legend')
      .style('cursor', function (d, i) {
        if (!self.clickable) {
          return 'default';
        }
        return 'pointer';
      })
      .on('click', function (d, i) {
        if (!self.clickable) {
          return;
        }
        self.onLegendClick(d, i, this);
      });

    legend.append('title').html(this.textCallback);

    legend.append('text')
      .attr('class', 'si-legend-label')
      .attr('y', 10)
      .text(this.textCallback)
      .each(function (d, i) {
        textDimensionInfo.push({ 'textLength': this.getComputedTextLength() });
      })
      .attr('x', function (d, i) {
        textDimensionInfo[i].xPos = 0;
        for (let a = 0; a <= i; a++) {
          textDimensionInfo[i].xPos -= textDimensionInfo[a].textLength + 20;
        }
        return textDimensionInfo[i].xPos;
      })
      .style('text-anchor', 'start')
      .style('fill', '#000');

    legend.append('rect')
      .attr('x', function (d, i) {
        return textDimensionInfo[i].xPos - 13;
      })
      .attr('y', 1)
      .attr('width', 10)
      .attr('height', 10)
      .attr('rx', 2)
      .attr('ry', 2)
      .style('fill', this.colorCallback);

    return legend;
  }

  onLegendClick(d: object, i: number, elem: object) {
    const self = this;
    d['clicked'] = !d['clicked'];
    this.changeClickedElemStyle(d, i, elem);

    const allNotClicked = self.data['some'](element => {
      return typeof (element.clicked) === 'undefined';
    });
    if (!allNotClicked) {
      self.data['forEach'](element => {
        element.clicked = undefined;
        self.revertElemStyle();
      });
    }
    self.legendClicked.emit([d, self.data]);
  }


  private changeClickedElemStyle(d: object, i: number, elem: object) {
    if (d['clicked']) {
      d3.select(elem).select('rect').style('fill', '#fff').style('stroke', '#000');
      // d3.select(elem).select("text").style("text-decoration", "line-through").style("stroke", "");
    } else {
      // tslint:disable:no-shadowed-variable
      d3.select(elem).select('rect').style('fill', (d) => this.colorCallback(d, i)).style('stroke', '');
      // d3.select(elem).select("text").style("text-decoration", "none");
    }
  }

  private revertElemStyle() {
    const self = this;
    this.legendContainerElem.selectAll('.si-chart-legend')
      .select('rect').style('fill', function (d, i) { return self.colorCallback(d, i); }).style('stroke', '');
    // this.legendContainerElem.selectAll(".si-chart-legend").select("text").style("text-decoration", "none");
  }

}
